











































import Vue, { VNode } from 'vue';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIcon } from '../sw-icon';
import { utilService } from '../util-service';

const cssPrefix = 'sw-chip';

/**
 * @event request-remove `(event: MouseEvent)`
 */
export default Vue.extend({
  functional: true,
  props: {
    theme: {
      type: String,
      default: 'light',
    },
    withClose: {
      type: Boolean,
      default: true,
    },
  },
  /* tslint:disable-next-line */
  render(h, context) {
    function onCloseClick(event: MouseEvent) {
      const removeEventHandle = context.listeners['request-remove'];
      if (typeof removeEventHandle !== 'function') { return; }
      removeEventHandle(event);
    }

    const data = utilService.extractFunctionalCompRootNodeData(context.data);

    return (
      <div
        class={[
          `${cssPrefix}`, `${cssPrefix}--${context.props.theme}`,
          'sw-typo-default', 'sw-flexbox', 'sw-flexbox--inline', 'sw-flexbox--center-items',
        ]}
        {...data}
      >
        <span class={[`${cssPrefix}__label`, 'sw-flexbox__flex']}>{context.children}</span>
        {
          context.props.withClose ? (
            <span class={[`${cssPrefix}__close`, 'sw-flexbox__flex-none']}>
              <SwIcon
                props-name="close"
                props-size={6}
                as-block
                nativeOn-click={onCloseClick}
              />
            </span>
          ) : undefined
        }
      </div>
    ) as VNode;
  },
}) as typeof SwExtendedVue;
